import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse, HttpHeaders} from '@angular/common/http';
import { parseHttpErrorBody } from '../forms/parse-http-error-body';
import 'rxjs/Rx';
import {Observable} from 'rxjs/Observable';

import {GlobalVariable} from '../../global';
import {Credentials} from './model/credentials.model';
import {User} from '../user/model/user.model';
import {AuthToken} from './model/auth-token.model';
import {UserService} from '../user/user.service';
import {
  RequestParameters
} from '../models/request-parameters/parameter.model';

@Injectable()
export class AuthService {

  private loginUrl: string = GlobalVariable.BASE_API_URL + '/auth-tokens';

  constructor(private http: HttpClient,
              private userService: UserService) {
    const userDataStored = window.localStorage.getItem('currentUser');
    if (userDataStored === null) {
      this.userService.currentUser.next(null);
    }else {
      this.userService.currentUser.next(JSON.parse(userDataStored));
    }
  }

  confirmAuthCode(body) {
    const body_copy = Object.assign({}, body);
    delete body_copy.login;
    return this.http.post(GlobalVariable.BASE_API_URL + '/auth-token/validate' , body_copy)
    .map(
      (authToken: AuthToken) => {
        const user = new User(body.login, null, authToken);
        window.localStorage.clear();
        window.localStorage.setItem('currentUser', JSON.stringify(user));
        this.userService.currentUser.next(user);
        return user;
      }
    )
    .catch(
      (error: HttpErrorResponse) => {
        return Observable.throw({
          code: error.status,
          content: JSON.parse(error.error),
          body: parseHttpErrorBody(error)
        });
      }
    );
  }
  resendCode(token){
    return this.http.get(GlobalVariable.BASE_API_URL+ '/auth-token/resend?token='+encodeURIComponent(token));
  }
  signinUser(credentials: Credentials) {
    return this.http.post(this.loginUrl, credentials)
      .map(
        (authToken: AuthToken) => {
          if (authToken.valid) {
            const user = new User(credentials.login, null, authToken);
            window.localStorage.clear();
            window.localStorage.setItem('currentUser', JSON.stringify(user));
            this.userService.currentUser.next(user);
            return user;
          } else {
            return authToken;
          }
        }
      )
      .catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error),
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  simpleAuthSigningUser(credentials: Credentials) {
    return this.http.post(this.loginUrl, credentials)
      .map(
        (authToken: AuthToken) => {
          const user = new User(credentials.login, null, authToken);
          window.localStorage.clear();
          window.localStorage.setItem('currentUser', JSON.stringify(user));
          this.userService.currentUser.next(user);
          return user;
        }
      )
      .catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error),
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  doubleAuthSigningUser(credentials: Credentials) {
    return this.http.post(this.loginUrl, credentials)
      .map(
        (authToken: AuthToken) => {
          return authToken;
        }
      )
      .catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error),
            body: parseHttpErrorBody(error)
          });
        }
      );
  }
  

  signOutUser() {
    window.localStorage.removeItem('currentUser');
  }

  deleteToken(reference) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/auth-token/' + reference).map(
      (response) => {
        return response;
      }
    );
  }

  isAuthenticated(): boolean {
    return this.userService.userExists();
  }

  getCurrentUserPermissions() {
    return this.http.get(GlobalVariable.BASE_API_URL + '/profile',  {
    }).map(
      (response: HttpResponse<any>) => {
        if (response) {
          return response;
        }
      }
    ).catch(
      (error: HttpErrorResponse) => {
        return Observable.throw({
          code: error.status,
          content: JSON.parse(error.error).message,
          body: parseHttpErrorBody(error)
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/auth/auth.service.ts